import state from '@/vuex/documento/state.js'
import getters from '@/vuex/documento/getters.js'
import mutations from '@/vuex/documento/mutations.js'
import actions from '@/vuex/documento/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
